module.exports = __webpack_public_path__ + "static/media/air-traffic-control.a173bf8a.jpg";